module.exports = __webpack_public_path__ + "static/media/Hair_4.15c3b58f.jpg";